import { render } from "./multilanguage.vue?vue&type=template&id=ce043c52"
import script from "./multilanguage.vue?vue&type=script&lang=js"
export * from "./multilanguage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__